import { APP_INITIALIZER, Inject, Injectable, Injector, DOCUMENT } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { BootstrapperBase } from '@trustedshops/tswp-core-common';
import { ProductFeatureUpgradeBannerComponent } from './product-feature-upgrade-banner.component';

@Injectable()
export class ProductFeatureUpgradeBannerBootstrapper implements BootstrapperBase {
  public constructor(
    private readonly _injector: Injector,
    @Inject(DOCUMENT) private readonly _document: Document
  ) {}

  public async initialize(): Promise<void> {
    const defaultView = this._document.defaultView;
    if (!defaultView) {
      return;
    }
    const customElement = createCustomElement(ProductFeatureUpgradeBannerComponent, {
      injector: this._injector,
    });
    defaultView.customElements.define(
      ProductFeatureUpgradeBannerComponent.selector,
      customElement
    );
  }
}

export const ProductFeatureUpgradeBannerInitializer = [
  ProductFeatureUpgradeBannerBootstrapper,
  {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: (initializer: BootstrapperBase) => () => initializer.initialize(),
    deps: [ProductFeatureUpgradeBannerBootstrapper],
  },
];
